import BottomSheetModal from "@/ui/composed/modal/BottomSheetModal/BottomSheetModal";

export type { BottomSheetModalProps } from "@/ui/composed/modal/BottomSheetModal/BottomSheetModal";
export default BottomSheetModal;
